<template>
    <div class="product-container">
        <nav class="add-navigation">
            <div class="nav-title white_space">
                About Company
            </div>
            <div class="icon" @click="$router.push({name: 'company-admin-company-info-edit', params: {id: company.company_uuid}})">
                <svg class="svg-grey"
                    width="30px"
                    height="30px"
                    viewBox="0 0 30 30"
                    version="1.1">
                    <path d="M21.0636684,5 L16.5223005,5 C16.0222902,5 15.6155648,5.41380074 15.6155648,5.92250923 L15.6155648,19.7548339 C15.6155648,20.0601476 15.7303938,20.4698893 15.8885285,20.7291513 L18.1395544,24.4204428 C18.2910881,24.6688561 18.5293057,24.8114391 18.793057,24.8114391 C19.0568083,24.8114391 19.2949534,24.6688561 19.4465596,24.420369 L21.6974404,20.7292251 C21.8556477,20.4698155 21.9704767,20.0601476 21.9704767,19.7548339 L21.9704767,5.92250923 C21.9704041,5.41380074 21.5636062,5 21.0636684,5 Z M19.1930363,22.7361624 L18.3929326,22.7361624 L17.1373575,20.6773432 L20.4485389,20.6773432 L19.1930363,22.7361624 Z M16.7035751,19.5703321 L16.7035751,8.61188192 L18.2488705,8.61188192 L18.2488705,19.5703321 L16.7035751,19.5703321 Z M19.3370259,19.5703321 L19.3370259,8.61188192 L20.8823212,8.61188192 L20.8823212,19.5703321 L19.3370259,19.5703321 Z M20.8823212,6.10701107 L20.8823212,7.50487085 L16.7036477,7.50487085 L16.7036477,6.10701107 L20.8823212,6.10701107 Z M16.4717409,23.8886347 C16.7721969,23.8886347 17.0157824,24.1364576 17.0157824,24.4421402 C17.0157824,24.7478229 16.7721969,24.9956458 16.4717409,24.9956458 L8.56943005,24.9956458 C8.26897409,24.9956458 8.0253886,24.7478229 8.0253886,24.4421402 C8.0253886,24.1363838 8.26897409,23.8886347 8.56943005,23.8886347 L16.4717409,23.8886347 Z"
                        id="path-1">
                    </path>
                </svg>
            </div>
        </nav>
        <div class="info-container">
            <div class="col-wrapper flex-column flex-md-row">
                <div class="col">
                    <div class="row">
                        <div class="header">Company Name</div>
                        <div v-if="company">{{company.company_name}}</div>
                    </div>
                    <div class="row">
                        <div class="header">Address1</div>
                        <div v-if="company">{{company.contact.address}}</div>
                    </div>
                    <div class="row">
                        <div class="header">City</div>
                        <div v-if="company">{{company.contact.city}}</div>
                    </div>
                    <div class="row">
                        <div class="header">Password</div>
                        <div v-if="company">*********</div>
                    </div>
                </div>
                <span></span>
                <div class="col">
                     <div class="row">
                        <div class="header">State</div>
                        <div v-if="company">{{company.contact.state}}</div>
                    </div>
                    <div class="row">
                        <div class="header">Country</div>
                        <div v-if="company">{{countryName}}</div>
                    </div>
                    <div class="row">
                        <div class="header">Zipcode</div>
                        <div v-if="company">{{company.contact.zipcode}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import { format } from 'date-fns'

export default {
  components: {
    SearchInput: () => import('@/components/Inputs/SearchInput.vue'),
    SecondaryButton: () => import('@/components/Buttons/SecondaryButton.vue'),
    ApprovedButton: () => import('@/components/Buttons/ApprovedButton.vue'),
    RejectedButton: () => import('@/components/Buttons/RejectedButton.vue'),
  },
  data: () => ({
      company: null,
      countryName: '',
  }),
  computed: {

  },
  created() {
   // this.company = this.$store.getters.getCompany;

    this.$store.dispatch('GetCompany', this.$store.getters.getUser.company_uuid).then( (res) => {
        this.company = res;
        this.$store.dispatch('UserGetCountry', this.company.contact.country_uuid).then( (res) => {
            this.countryName = res.nice_name // this.$store.getters.getCountry;
        })
    });
  },
  mounted() {

  },
  methods: {
      transformTemplates (i, k) {
      return {
        name:  i.company_name,
        city: i.contact.city,
        zipCode: i.contact.zipcode,
        state: i.contact.state,
        address: i.contact.address,
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.product-container {
    padding: 0 20px;
    .add-navigation {
        font-family: "Helvetica Neue";
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        margin-top: 20px;
        margin-bottom: 20px;
        .nav-title {
            height: 30px;
            width: 432px;
            color: #000000;
            font-size: 18px;
            font-weight: 500;
            line-height: 30px;

        }
        .icon {
            .svg-grey {

            }
        }
    }
    .info-container {
        background-color: #FFFFFF;
        flex-direction: column;
        align-items: center;
        .col-wrapper {
            width: 100%;
            display: flex;
            justify-content: space-between;
            span {
                width: 60px;
            }
            .col {
                width: 100%;
                .row {
                    display: flex;
                    align-items: center;
                    //border-radius: 4px 4px 0 0;
                    // box-shadow: inset 0 -1px 0 0 #F0F1FA;
                    border-top: 1px solid #F0F1FA;
                    border-bottom: 1px solid #F0F1FA;
                    .header {
                        width: 50%;
                        color: #212B36;
                        font-family: "Helvetica Neue";
                        font-weight: 600;
                        font-size: 14px;
                        line-height: 20px;


                    }
                    div {
                        width: 50%;
                        color: #212B36;
                        font-family: "Helvetica Neue";
                        font-weight: normal;
                        font-size: 14px;
                        line-height: 20px;
                        padding: 12px 0 12px 9px;
                    }
                }
            }
        }
    }
}
</style>



